import(/* webpackMode: "eager" */ "/home/runner/work/sapling/sapling/node_modules/.pnpm/next@15.5.28_@playwright+test@1.58.2_@types+node@24.13.6_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["BookBuyButtons"] */ "/home/runner/work/sapling/sapling/packages/foundation/src/app/(other)/bocker/messis-dagbok/purchase.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/home/runner/work/sapling/sapling/packages/foundation/src/components/FadeIn.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/sapling/sapling/packages/foundation/src/images/messis-dagbok/cover.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/sapling/sapling/packages/foundation/src/images/messis-dagbok/first-page-illustration.png");
